export class GatewayTimeoutError extends Error {
  code = 504;

  constructor() {
    super();
  }
}
